import React from "react";
import Box from "@mui/material/Box";
import GoToPng from "src/assets/images/GoTo.png"; // ✅ place your PNG in this folder

const GoToIcon = ({ size = 55, ...props }) => (
  <Box
    component="img"
    src={GoToPng}
    alt="Go To Icon"
    sx={{
      width: size,
      height: size,
      display: "inline-block"
    }}
    {...props}
  />
);

export default GoToIcon;
